import React from 'react';
import Calendar from 'react-calendar';
import { Translate } from '../../language/index';
import { UploadImage } from '../../components/Register/UploadFile';
import Button from '../../utils/components/Button/Button'
import Input from '../../utils/components/Input/Input'
import ModalTermsAndConditions from '../ModalTermsAndConditions/ModalTermsAndConditions';
import Navbar from '../Navbar/Navbar/Navbar';
import BackGroundLogin from '../../assets/img/background.png';
import './ViewRegister.css';

const ViewRegister = ({
    isCodeReferal,
    code,
    year,
    month,
    day,
    sendRegisterUser,
    error,
    date,
    setIsEnabled,
    gender,
    setGender,
    maxDateCalendar,
    history,
    file,
    setFile,
    picture,
    setPicture,
    email,
    setEmail,
    nameUser,
    setNameUser,
    latsNameUser,
    setLatsNameUser,
    password,
    setPassword,
    phone,
    setPhone,
  
    setConfirmPassword,
    confirmPassword,
    isAcceptTerms,
    dateView,
    isVisibleCalendar,
    setIsVisibleCalendar,
    refVisibleCalendar,
    isValidate,
    setValidate,
    isShowModalTerms,
    setIsShowModalTerms,
    selectTerms = () => { },
    selectPikerProfile = () => { },
    onChange = () => { },
    isChecked = () => { },
    isFocused = () => { },
    referalcode,
    setReferalode,
    checkCode = () => { },
    setiIsCodeReferal = () => { },
    cleanCodeReferal = () => { },
    isEmpty = () => { } }) => {
    return (
        <div className={'container-register'}>
            <img className="background-register" src={BackGroundLogin} alt="imagen de login"></img>
            <Navbar  islogin={false}/>
            <div className="title-register">{isShowModalTerms ? Translate('titleModalTerms', 'es') : Translate('register', 'es')}</div>
            <>
                {isShowModalTerms ? <ModalTermsAndConditions isAcceptTerms={isAcceptTerms} displayModal={isShowModalTerms} isChecked={isChecked} closeModal={selectTerms} /> :
                    <div className="form-register">
                        <div className='row centerItems'>
                            <div className="content-icon-register">
                                <UploadImage
                                    picture={picture}
                                    setPicture={setPicture}
                                    setFile={setFile}
                                />

                            </div>
                        </div>
                        <div className='row centerItems centerContent'>
                            <div className="content-inputs-register">

                                <Input
                                    classNameContent='input-class-register'
                                    name="name"
                                    type="text"
                                    placeholder={'* ' + Translate('name', 'es')}
                                    value={nameUser}
                                    onChange={e => setNameUser(e.target.value.trimStart())}
                                    onBlur={e => isEmpty(e)}
                                    onFocus={e => isFocused(e)}
                                    onMouseOut={e => setNameUser(e.target.value.trim())}
                                    onKeyUp={isEmpty ? e => isEmpty(e) : () => { }}
                                    error={error.name}
                                />

                                <Input
                                    classNameContent='input-class-register'
                                    name="lastname"
                                    type="text"
                                    placeholder={'* ' + Translate('lastName', 'es')}
                                    value={latsNameUser}
                                    onChange={e => setLatsNameUser(e.target.value.trimStart())}
                                    onBlur={e => isEmpty(e)}
                                    onFocus={e => isFocused(e)}
                                    onMouseOut={e => setLatsNameUser(e.target.value.trim())}
                                    onKeyUp={isEmpty ? e => isEmpty(e) : () => { }}
                                    error={error.lastname}
                                />

                                <div>
                                    <Input
                                        classNameContent=''
                                        classNameInput='pointer input-class-register'
                                        name="birthDate"
                                        type="text"
                                        placeholder={'* ' + Translate('birthDate', 'es')}
                                        value={dateView}
                                        onClick={() => setIsVisibleCalendar(true)}
                                        autoComplete='off'
                                        error={error.birth}
                                    />
                                    {isVisibleCalendar &&
                                        <div ref={refVisibleCalendar}>
                                            <div style={{
                                                display: isVisibleCalendar ? 'block' : 'none'
                                            }}
                                                className="calendar-register"
                                            >
                                                <Calendar
                                                    maxDate={maxDateCalendar}
                                                    onChange={(dateTime) => onChange(dateTime)}
                                                    value={date}
                                                />
                                            </div>
                                        </div>
                                    }
                                </div>

                                <select
                                    name={"gender"}
                                    className='mt-4 background-white input-select-style'
                                    value={gender}
                                    onChange={e => setGender(e.target.value.trimStart())}
                                    onFocus={e => isFocused(e)}
                                    onMouseOut={e => setGender(e.target.value.trim())}
                                >
                                    <option value="">{Translate("gender", 'es')}</option>
                                    <option value="male">Masculino</option>
                                    <option value="female">Femenino</option>
                                    <option value="another">Prefiero no decirlo</option>
                                </select>

                                <Input
                                    classNameContent='input-class-register'
                                    name="phone"
                                    type="text"
                                    placeholder={'* ' + Translate('phone', 'es')}
                                    value={phone}
                                    onChange={e => setPhone(e.target.value.trimStart())}
                                    onBlur={e => isEmpty(e)}
                                    onFocus={e => isFocused(e)}
                                    onMouseOut={e => setPhone(e.target.value.trim())}
                                    onKeyUp={isEmpty ? e => isEmpty(e) : () => { }}
                                    error={error.phone}
                                />

                                <Input
                                    classNameContent='input-class-register'
                                    name="email"
                                    type="email"
                                    placeholder={'* ' + Translate('email', 'es')}
                                    value={email}
                                    onChange={e => setEmail(e.target.value.trimStart())}
                                    onBlur={e => isEmpty(e)}
                                    onFocus={e => isFocused(e)}
                                    onMouseOut={e => setEmail(e.target.value.trim())}
                                    onKeyUp={isEmpty ? e => isEmpty(e) : () => { }}
                                    error={error.email}
                                />

                                <Input

                                    classNameContent='input-class-register'
                                    name="password"
                                    type="password"
                                    autoComplete="new-password"
                                    placeholder={Translate('password', 'es')}
                                    onChange={e => setPassword(e.target.value.trimStart())}
                                    value={password}
                                    onBlur={e => isEmpty(e)}
                                    onFocus={e => isFocused(e)}
                                    onKeyUp={isEmpty ? e => isEmpty(e) : () => { }}
                                    error={error.password}
                                />


                                <Input
                                    classNameContent='input-class-register'
                                    name="confirmPassword"
                                    type="password"
                                    autoComplete="new-password"
                                    placeholder={Translate('confirmPassword', 'es')}
                                    value={confirmPassword}
                                    onChange={e => setConfirmPassword(e.target.value.trimStart())}
                                    onBlur={e => isEmpty(e)}
                                    onFocus={e => isFocused(e)}
                                    onKeyUp={isEmpty ? e => isEmpty(e) : () => { }}
                                    error={error.confirmPassword}
                                />
                               {
                                    !code.valid ? (
                                        <Input
                                            error={(isCodeReferal && (code.valid === false)) && "Código invalido"}
                                            classNameContent="input-class-register-code"
                                            name="referralCode"
                                            type="text"
                                            placeholder={Translate('referralCode', 'es')}
                                            value={referalcode}
                                            onChange={e => {
                                                cleanCodeReferal()
                                                if (e.target.value.length > 0) {
                                                    setiIsCodeReferal(true)
                                                } else {
                                                    setiIsCodeReferal(false)
                                                }

                                                setReferalode(e.target.value.trimStart())
                                            }
                                            }
                                            onBlur={e => isEmpty(e)}
                                            onFocus={e => isFocused(e)}
                                            onMouseOut={e => setReferalode(e.target.value.trim())}
                                            onKeyUp={isEmpty ? e => isEmpty(e) : () => { }}
                                        />
                                    ) : (
                                        <div>
                                            {code.user.name} {code.user.lastname}
                                        </div>
                                    )
                                }
                                <Button
                                    onClick={() => {
                                        if (isCodeReferal) {
                                            checkCode(referalcode)

                                        }

                                    }}
                                    text='Verificar' />
                            </div>

                            <div className="content-acept-terms-register">
                                <input
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (!isAcceptTerms) {
                                            selectTerms(e)
                                        } else {
                                            isChecked()
                                        }
                                    }} checked={isAcceptTerms} type="checkbox" id="check-register" />
                                <label htmlFor="check-register" className="acept-terms-register">
                                    {Translate('messageAcceptTerms', 'es')}
                                </label>
                            </div>
                            <div className="text-error-input">{error.checkTermsOfService}</div>
                            <Button
                                classNameContent='send-register-button'
                                theme={'white'}
                                disabled={isValidate ? false : true}
                                text={Translate('buttonRegister', 'es')}
                                onClick={() => {
                                    console.log();
                                    sendRegisterUser({
                                        email: email,
                                        picture: file,
                                        name: nameUser.trim(),
                                        lastname: latsNameUser.trim(),
                                        birthDate: date.toISOString(),
                                        password: password.trim(),

                                        phone: phone,
                                        //  ubication: { originCity: originCity, currentCity: currentCity },
                                        email: email,
                                        birthday: [year, month, day].join('-'),
                                        isAcceptTerms: true,
                                        gender,

                                        ...(code.valid && { referralCode: code.user._id })
                                        //isDataVerified: true,
                                        //  isEmailVerified: true, 
                                        //   zodiacSign: zodiacSign 
                                    }, history)
                                }}
                            />
                        </div>
                    </div>
                }
            </>
        </div >
    )
}

export default ViewRegister